import script from "./announcement.vue?vue&type=script&setup=true&lang=js"
export * from "./announcement.vue?vue&type=script&setup=true&lang=js"

import "./announcement.vue?vue&type=style&index=0&id=ad50fb38&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ad50fb38"]])

export default __exports__